<button class="btn btn-link text-decoration-none btn-block text-white mt-4" (click)="profile()">
  <i class="bx bx-user-pin"></i>Profile
</button>
